import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faSignOutAlt, faBars } from '@fortawesome/free-solid-svg-icons';
import { auth } from '../firebase-config';
import './Header.css';

const Header = ({ onMenuClick, user, onLoginClick }) => {
  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <header className="landing-header">
      <div className="header-left">
        <button 
          className="hamburger-button" 
          onClick={onMenuClick} 
          aria-label="Menu"
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <FontAwesomeIcon 
            icon={faBars} 
            style={{ 
              fontSize: '24px', 
              color: '#2c3e50' 
            }} 
          />
        </button>
      </div>
      <div className="header-center">
        <h1>Sigmund</h1>
      </div>
      <div className="header-right">
        {/* Login/Logout buttons removed */}
      </div>
    </header>
  );
};

export default Header; 